import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown } from "./IDropdown";
export enum SubmissionType {
  C2C = 1,
  Contract = 2,
  Permanent = 3
}
export enum TaxTerm {
  Tax_1099_All_Inclusive = 1,
  Tax_1099_With_Benefits = 2,
  C2C_All_Inclusive = 3,
  C2C_With_Benefits = 4,
  C2C_Without_Benefits = 5,
  Permanent = 6,
  W2_All_Inclusive = 7,
  W2_With_Benefits = 8
}
export enum PaymentTerm {
  Net_Seven = 1,
  Net_Fifteen = 2,
  Net_Thirty = 3,
  Net_Forty_Five = 4,
  Net_Sixty = 5,
  Pay_On_Pay = 6,
}

export interface IConsultantMast {
  identityType?: "Email ID" | "Cons. ID";
  identity?: string;

  consultant_ID?: number; //cm
  consultant_Name?: string; //cm
  consultant_Email_ID?: string; //cm
  consultant_Home_No?: string; //cm
  consultant_Job_Title?: string; //cm
  visa_Status?: number; //cm
  visa_Received_By?: number, // 1 - Consultant ,, 2 - Subvendor
  visa_Received_Path?: string,
  consultant_State?: string; //cm
  consultant_City?: number; //cm
  total_Experience?: number; //cm
  linkedin?: string; //cm
  availability?: string; //cm
  hourly_Rate?: number; //cm
  concent?: string; //cm
  mathingProfilePer?: number; //cm
  dobdd?: string; //cm
  dobmm?: string; //cm
  dobyyyy?: string; //cm
  dob?: string; //cm
  ssn?: string; //cm
  annual_Salary?: number; //cm
  consultant_Country?: number; //cm
  state_Name?: string;
  city_Name?: string;
  degree?: string; //ce
  passoutYear?: string; //ce
  country_Name?: string; //ce
  university_ID?: number;
  university_Name?: string;
  tax_Term?: TaxTerm; //csl
  payment_Term?: PaymentTerm | null;
  faceToFaceInterview?: boolean; //csl
  addition_Info?: string; //csl
  submissionType?: SubmissionType; //csl
  buying_Rate?: number; //csl
  submittal_Rate?: number; //csl
  vendor_Company_Name?: string;
  contact_Person_EmailID?: string; //scp
  vendor_Company_ID?: number; //scp
  contact_Person_Name?: string; //scp
  phone_No?: string; //scp
  requirement_ID?: number;

  consultant_Resume_Path?: string;
  createdOn?: Date;
  consultant_Added_ByUser?: number;
  consultant_Status?: string;

  city?: ICityMastDropdown;
  state?: IStateMastDropdown;
  country?: ICountryMastDropdown;
  company?: IClientCompanyDropdown;
  university?: IUniversityDropdown;

  r1_Ref_ID?: number;
  r1_Company_Name?: string;
  r1_POC_Name?: string;
  r1_Phone?: string;
  r1_Email?: string;
  r2_Ref_ID?: number;
  r2_Company_Name?: string;
  r2_POC_Name?: string;
  r2_Phone?: string;
  r2_Email?: string;
  r3_Ref_ID?: number;
  r3_Company_Name?: string;
  r3_POC_Name?: string;
  r3_Phone?: string;
  r3_Email?: string;

  req_Understand_Percentage?: number;
  req_Understood_Comment?: string;
  req_NotUnderstood_Comment?: string;

  blacklisted_SV_Sub_Reason?: string;
}

export interface IConsultantRef {
  ref_ID?: number;
  consultant_ID?: number;
  company_Name?: string;
  poC_Name?: string;
  phone?: string;
  email?: string;
}
